import React from "react";
import styles from "../css/styles.module.css";

export default function Profile(props) {
  //get the first character of the dislay name
  const profileLetter = props.user.userData.displayName.charAt(0);

  return (
    <div className={styles.profile}>
      <h3>Current User</h3>
      <p className={styles.profilePic}>{profileLetter}</p>
      {props.user.isAdmin && <p><b>Admin</b></p>}
      <p>{props.user.userData.displayName}</p>
      <p className={styles.wordWrap}>{props.user.userData.email}</p>
    </div>
  );
}
